import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router, NavigationEnd } from '@angular/router';
import { Service } from './service';
import { Subject } from 'rxjs';
import { Chart } from 'angular-highcharts';
import { numberFormat } from 'highcharts';
import * as Highcharts from 'highcharts';
import * as pbi from 'powerbi-client';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

  @ViewChild('reportContainer', { static: true }) reportContainer: ElementRef;

  show = false;
  fullScreen = true;
  template = ``;

  user_role: any;
  validmsg: any;
  resstatus = localStorage.getItem('resstatus');
  type_name = localStorage.getItem('type_name');
  username = localStorage.getItem('username');

  pieChart1: Chart;
  pieChart2: Chart;
  pieChart3: Chart;  
  areaChart: Chart;
  barChart1: Chart;
  barChart2: Chart;
  barChart3: Chart;
  donutChart1: Chart;
  donutChart2: Chart;
  donutChart3: Chart;
  donutChart4: Chart;
  donutChart5: Chart;
  donutChart6: Chart;
  donutChart7: Chart;
  donutChart8: Chart;

  dtOptions: DataTables.Settings = {
    destroy: true,
    scrollY: 150,
    columnDefs: [
      { orderable: true, className: 'reorder', targets: 0 },
      { orderable: true, targets: '_all' }
    ]
  };
  dtTrigger: Subject<any> = new Subject<any>();

  readaccess   : any = 1;
  writeaccess  : any = 1;
  deleteaccess :  any = 1;
  modulename = 'claim_executive_dashboard';

  constructor(private fb: FormBuilder, private dataservice: Service, private route: Router) {
    this.route.events.subscribe((e) => {
      if (e instanceof NavigationEnd) {
        this.user_role = localStorage.getItem('type_name');
      }
      if (this.resstatus == null) {
        this.route.navigate(['/home']);
      }
    });
  }

  ngOnInit(): void {

    this.initGroup();
  
  }

  initGroup(){
    this.PieChart1();
    this.PieChart2();
    this.PieChart3();    
    this.AreaChart();
    this.BarChart1();
    this.BarChart2();
    this.BarChart3();
    this.DonutChart1();
    this.DonutChart2();
    this.DonutChart3();
    this.DonutChart4();
    this.DonutChart5();
    this.DonutChart6();
    this.DonutChart7();
    this.DonutChart8();
    this.embedPowerBIReport(); 
  }  

  PieChart1() {

    const data1 = [
      { name: 'Branch 1', y: 40000 },
      { name: 'Branch 2', y: 30000 },
      { name: 'Branch 3', y: 20000 },
      { name: 'Branch 4', y: 10000 }
    ];
  
    const chartWidth = window.innerWidth > 1900 ? 360 : 270;
  
    this.pieChart1 = new Chart({
      chart: {
        type: 'bar',
        height: 240,
        width: chartWidth,
        marginLeft: 65,
        marginBottom: 60
      },
      title: {
        text: '',
        style: {
          fontSize: '12px',
          color: '#000',
          fontFamily: '"Poppins", sans-serif',
          fontWeight: 'bold'
        }
      },
      xAxis: {
        categories: data1.map(item => item.name), // Use name values as categories for y-axis
        title: {
          text: 'Companies' // Title for y-axis
        },
        labels: {
          useHTML: true,
          formatter: function() {
            const text = this.value.toString();
            const maxLabelLength = 10; // Adjust the length as needed
            const displayedText = text.length > maxLabelLength ? text.slice(0, maxLabelLength) + '...' : text;
            return `<span title="${text}">${displayedText}</span>`;
          },
          style: {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
          }
        }
      },
      series: [{
        name: '',
        type: 'bar',
        data: data1.map(item => ({
          y: item.y,
          color: item.y <= 60 ? '#00D63C' : item.y <= 75 ? '#00D63C' : '#00D63C' // Define color based on value range
        })),
        pointWidth: 15
      }],
      exporting: {
        enabled: false
      },
      plotOptions: {
        bar: {
          dataLabels: {
            enabled: true,
            format: '{point.y}'
          }
        }
      },
      legend: {
        enabled: false // Disable legend since it's not necessary for this configuration
      },
      yAxis: {
        title: {
          text: '' // Title for x-axis
        }
      }
    });
  
  }  
  
  PieChart2() {

    const data1 = [
      { name: 'Branch 1', y: 40000 },
      { name: 'Branch 2', y: 30000 },
      { name: 'Branch 3', y: 20000 },
      { name: 'Branch 4', y: 10000 }
    ];
  
    const chartWidth = window.innerWidth > 1900 ? 360 : 270;
  
    this.pieChart2 = new Chart({
      chart: {
        type: 'bar',
        height: 240,
        width: chartWidth,
        marginLeft: 65,
        marginBottom: 60
      },
      title: {
        text: '',
        style: {
          fontSize: '12px',
          color: '#000',
          fontFamily: '"Poppins", sans-serif',
          fontWeight: 'bold'
        }
      },
      xAxis: {
        categories: data1.map(item => item.name), // Use name values as categories for y-axis
        title: {
          text: 'Companies' // Title for y-axis
        },
        labels: {
          useHTML: true,
          formatter: function() {
            const text = this.value.toString();
            const maxLabelLength = 10; // Adjust the length as needed
            const displayedText = text.length > maxLabelLength ? text.slice(0, maxLabelLength) + '...' : text;
            return `<span title="${text}">${displayedText}</span>`;
          },
          style: {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
          }
        }
      },
      series: [{
        name: '',
        type: 'bar',
        data: data1.map(item => ({
          y: item.y,
          color: item.y <= 60 ? '#00D63C' : item.y <= 75 ? '#00D63C' : '#00D63C' // Define color based on value range
        })),
        pointWidth: 15
      }],
      exporting: {
        enabled: false
      },
      plotOptions: {
        bar: {
          dataLabels: {
            enabled: true,
            format: '{point.y}'
          }
        }
      },
      legend: {
        enabled: false // Disable legend since it's not necessary for this configuration
      },
      yAxis: {
        title: {
          text: '' // Title for x-axis
        }
      }
    });

  }

  PieChart3() {

    const data1 = [
      { name: 'Branch 1', y: 10000 },
      { name: 'Branch 2', y: 30000 }
    ];

    const chartWidth = window.innerWidth > 1900 ? 360 : 270;

    this.pieChart3 = new Chart({
      chart: {
        type: 'pie',
        height: 240,
        width: chartWidth,
        // margin: [20, 20, 20, 20], // Reduce margins
        // spacing: [15, 15, 15, 15] // Reduce spacing
      },
      title: {
        text: 'Premium Spent',
        style: {
          fontSize: '12px',
          color: '#000',
          fontFamily: '"Poppins", sans-serif',
          fontWeight: 'bold'
        }
      },
      series: [{
        name: 'Data',
        type: 'pie',
        data: data1
      }],
      exporting: {
        enabled: false
      },
      plotOptions: {
        pie: {
          colors: ['#FFBF3F', '#173F35'],
          dataLabels: {
            enabled: true, // Enable data labels
            format: '{point.y}', // Display name and percentage
            distance: 5 // Position data labels outside the pie slices
          },
          size: '100%', // Make the pie chart take up full width
          showInLegend: true
        }
      },
      legend: {
        enabled: true,
        layout: 'horizontal',
        align: 'center',
        verticalAlign: 'bottom',
        itemStyle: {
          fontFamily: '"Poppins", sans-serif',
          fontSize: '12px',
          color: '#000'
        },
        symbolHeight: 10, // Set symbol height to make it a square
        symbolWidth: 10,  // Set symbol width to make it a square
        symbolRadius: 0 // Make legend symbol square
      }
    });

  }  

  AreaChart() {

    const data1 = [
      { name: '0', y: 'JAN' },
      { name: '70.00', y: 'JAN' },
      { name: '25.00', y: 'FEB' },
      { name: '154.00', y: 'MAR' },
      { name: '120.00', y: 'APR' },
      { name: '22.00', y: 'MAY' }
    ];

    const chartWidth = window.innerWidth > 1900 ? 360 : 270;

    this.areaChart = new Chart({
      chart: {
        type: 'area',
        height: 240,
        width: chartWidth,
        // margin: [30, 30, 60, 30], // Reduce margins
        marginLeft: 35,
        marginBottom: 60
      },
      title: {
        text: '',
        style: {
          fontSize: '12px',
          color: '#000',
          fontFamily: '"Poppins", sans-serif',
          fontWeight: 'bold'
        }
      },
      xAxis: {
        categories: data1.map(d => d.y),
        title: {
          text: '',
          style: {
            fontSize: '10px',
            color: '#000',
            fontFamily: '"Poppins", sans-serif'
          }
        }
      },
      yAxis: {
        title: {
          text: '', // amount
          style: {
            fontSize: '10px',
            color: '#000',
            fontFamily: '"Poppins", sans-serif'
          }
        }
      },
      series: [{
        name: 'Claim ratio',
        type: 'area',
        data: data1.map(d => parseFloat(d.name))
      }],
      exporting: {
        enabled: false
      },
      plotOptions: {
        area: {
          fillColor: '#173F35',
          lineColor: '#FFA500',
          fillOpacity: 0.5,
          dataLabels: {
            enabled: true,
            format: '{point.y}', // Display value
          },
          marker: {
            fillColor: '#173F35', // Set marker color
            lineColor: '#173F35'  // Set marker border color
          },
          showInLegend: true
        }
      },
      legend: {
        enabled: true,
        layout: 'horizontal',
        align: 'center',
        verticalAlign: 'bottom',
        itemStyle: {
          fontFamily: '"Poppins", sans-serif',
          fontSize: '12px',
          color: '#000'
        },        
        symbolHeight: 10, // Set symbol height to make it a square
        symbolWidth: 10,  // Set symbol width to make it a square
        symbolRadius: 0 // Make legend symbol square
      }
    });

  }

  BarChart1() {
    const data1 = [
      { name: 'ICICI', y: 85 },
      { name: 'BAJAJ', y: 30 },
      { name: 'PNB', y: 30 }
    ];
  
    const chartWidth = window.innerWidth > 1900 ? 360 : 270;
  
    this.barChart1 = new Chart({
      chart: {
        type: 'bar',
        height: 240,
        width: chartWidth,
        marginLeft: 45,
        marginBottom: 60
      },
      title: {
        text: '',
        style: {
          fontSize: '12px',
          color: '#000',
          fontFamily: '"Poppins", sans-serif',
          fontWeight: 'bold'
        }
      },
      xAxis: {
        categories: data1.map(item => item.name), // Use name values as categories for y-axis
        title: {
          text: 'Companies' // Title for y-axis
        }
      },
      series: [{
        name: '',
        type: 'bar',
        data: data1.map(item => ({
          y: item.y,
          color: item.y <= 60 ? '#00D63C' : item.y <= 75 ? '#00D63C' : '#00D63C' // Define color based on value range
        })),
        pointWidth: 15
      }],
      exporting: {
        enabled: false
      },
      plotOptions: {
        bar: {
          dataLabels: {
            enabled: true,
            format: '{point.y}'
          }
        }
      },
      legend: {
        enabled: false // Disable legend since it's not necessary for this configuration
      },
      yAxis: {
        title: {
          text: '' // Title for x-axis
        }
      }
    });
  }
             
  BarChart2() {

    const data1 = [
      { name: 'GMC', y: 85 },
      { name: 'OPD', y: 30 },
      { name: 'TITLE 1', y: 30 }
    ];
  
    const chartWidth = window.innerWidth > 1900 ? 360 : 270;
  
    this.barChart2 = new Chart({
      chart: {
        type: 'bar',
        height: 240,
        width: chartWidth,
        marginLeft: 45,
        marginBottom: 70
      },
      title: {
        text: '',
        style: {
          fontSize: '12px',
          color: '#000',
          fontFamily: '"Poppins", sans-serif',
          fontWeight: 'bold'
        }
      },
      xAxis: {
        categories: data1.map(item => item.name), // Use name values as categories for y-axis
        title: {
          text: 'Companies' // Title for y-axis
        }
      },
      series: [{
        name: '',
        type: 'bar',
        data: data1.map(item => ({
          y: item.y,
          color: item.y <= 60 ? '#00D63C' : item.y <= 75 ? '#00D63C' : '#00D63C' // Define color based on value range
        })),
        pointWidth: 15
      }],
      exporting: {
        enabled: false
      },
      plotOptions: {
        bar: {
          dataLabels: {
            enabled: true,
            format: '{point.y}'
          }
        }
      },
      legend: {
        enabled: false // Disable legend since it's not necessary for this configuration
      },
      yAxis: {
        title: {
          text: '' // Title for x-axis
        }
      }
    });

  }

  BarChart3() {

    const data1 = [
      { name: 'GMC', y: 85 },
      { name: 'OPD', y: 30 },
      { name: 'TITLE 1', y: 30 }
    ];
  
    const chartWidth = window.innerWidth > 1900 ? 360 : 270;
  
    this.barChart3 = new Chart({
      chart: {
        type: 'bar',
        height: 240,
        width: chartWidth,
        marginLeft: 45,
        marginBottom: 70
      },
      title: {
        text: '',
        style: {
          fontSize: '12px',
          color: '#000',
          fontFamily: '"Poppins", sans-serif',
          fontWeight: 'bold'
        }
      },
      xAxis: {
        categories: data1.map(item => item.name), // Use name values as categories for y-axis
        title: {
          text: 'Companies' // Title for y-axis
        }
      },
      series: [{
        name: '',
        type: 'bar',
        data: data1.map(item => ({
          y: item.y,
          color: item.y <= 60 ? '#00D63C' : item.y <= 75 ? '#00D63C' : '#00D63C' // Define color based on value range
        })),
        pointWidth: 15
      }],
      exporting: {
        enabled: false
      },
      plotOptions: {
        bar: {
          dataLabels: {
            enabled: true,
            format: '{point.y}'
          }
        }
      },
      legend: {
        enabled: false // Disable legend since it's not necessary for this configuration
      },
      yAxis: {
        title: {
          text: '' // Title for x-axis
        }
      }
    });

  }

  DonutChart1() {    
    const data1 = [
      { name: 'Client 1', y: 15 },
      { name: 'Client 2', y: 10 },
      { name: 'Client 3', y: 10 },
      { name: 'Client 4', y: 20 },
      { name: 'Client 5', y: 10 },
      { name: 'Other', y: 35 }
    ];

    const chartWidth = window.innerWidth > 1900 ? 360 : 270;    
  
    this.donutChart1 = new Chart({
      chart: {
        type: 'pie',
        height: 240,
        width: chartWidth,
      },
      title: {
        text: ''
      },
      series: [{
        name: 'Share',
        type: 'pie',
        innerSize: '60%', // Set inner size to make it a donut chart
        data: data1
      }],
      exporting: {
        enabled: false
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          colors: ['#FFBF3F', '#FFA500', '#F9423A', '#A0231D', '#057A88', '#173F35'],
          cursor: 'pointer',
          dataLabels: {
            format: '{point.y}', // Display name and percentage
            distance: 5 // Position data labels outside the pie slices
          },
          size: '100%',
          showInLegend: true
        }
      },
      tooltip: {
        pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
      },
      legend: {
        enabled: true,
        layout: 'horizontal',
        align: 'center',
        verticalAlign: 'bottom',
        itemStyle: {
          fontFamily: '"Poppins", sans-serif',
          fontSize: '12px',
          color: '#000'
        },
        symbolHeight: 10, // Set symbol height to make it a square
        symbolWidth: 10,  // Set symbol width to make it a square
        symbolRadius: 0 // Make legend symbol square
      }
    });  
  }

  DonutChart2() {    
    const data1 = [
      { name: 'RM 1', y: 15 },
      { name: 'RM 2', y: 10 },
      { name: 'RM 3', y: 10 },
      { name: 'RM 4', y: 20 },
      { name: 'RM 5', y: 10 },
      { name: 'Other', y: 35 }
    ];

    const chartWidth = window.innerWidth > 1900 ? 360 : 270;    
  
    this.donutChart2 = new Chart({
      chart: {
        type: 'pie',
        height: 240,
        width: chartWidth,
      },
      title: {
        text: ''
      },
      series: [{
        name: 'Share',
        type: 'pie',
        innerSize: '60%', // Set inner size to make it a donut chart
        data: data1
      }],
      exporting: {
        enabled: false
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          colors: ['#FFBF3F', '#FFA500', '#F9423A', '#A0231D', '#057A88', '#173F35'],
          cursor: 'pointer',
          dataLabels: {
            format: '{point.y}', // Display name and percentage
            distance: 5 // Position data labels outside the pie slices
          },
          size: '100%',
          showInLegend: true
        }
      },
      tooltip: {
        pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
      },
      legend: {
        enabled: true,
        layout: 'horizontal',
        align: 'center',
        verticalAlign: 'bottom',
        itemStyle: {
          fontFamily: '"Poppins", sans-serif',
          fontSize: '12px',
          color: '#000'
        },
        symbolHeight: 10, // Set symbol height to make it a square
        symbolWidth: 10,  // Set symbol width to make it a square
        symbolRadius: 0 // Make legend symbol square
      }
    });  
  }

  DonutChart3() {    
    const data1 = [
      { name: 'RM 1', y: 15 },
      { name: 'RM 2', y: 10 },
      { name: 'RM 3', y: 10 },
      { name: 'ICICI 4', y: 20 },
      { name: 'BAJAJ 5', y: 10 },
      { name: 'Other', y: 35 }
    ];

    const chartWidth = window.innerWidth > 1900 ? 360 : 270;    
  
    this.donutChart3 = new Chart({
      chart: {
        type: 'pie',
        height: 240,
        width: chartWidth,
      },
      title: {
        text: ''
      },
      series: [{
        name: 'Share',
        type: 'pie',
        innerSize: '60%', // Set inner size to make it a donut chart
        data: data1
      }],
      exporting: {
        enabled: false
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          colors: ['#FFBF3F', '#FFA500', '#F9423A', '#A0231D', '#057A88', '#173F35'],
          cursor: 'pointer',
          dataLabels: {
            format: '{point.y}', // Display name and percentage
            distance: 5 // Position data labels outside the pie slices
          },
          size: '100%',
          showInLegend: true
        }
      },
      tooltip: {
        pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
      },
      legend: {
        enabled: true,
        layout: 'horizontal',
        align: 'center',
        verticalAlign: 'bottom',
        itemStyle: {
          fontFamily: '"Poppins", sans-serif',
          fontSize: '12px',
          color: '#000'
        },
        symbolHeight: 10, // Set symbol height to make it a square
        symbolWidth: 10,  // Set symbol width to make it a square
        symbolRadius: 0 // Make legend symbol square
      }
    });  
  }

  DonutChart4() {    
    const data1 = [
      { name: 'RM 1', y: 15 },
      { name: 'RM 2', y: 10 },
      { name: 'RM 3', y: 10 },
      { name: 'ICICI 4', y: 20 },
      { name: 'BAJAJ 5', y: 10 },
      { name: 'Other', y: 35 }
    ];

    const chartWidth = window.innerWidth > 1900 ? 360 : 270;    
  
    this.donutChart4 = new Chart({
      chart: {
        type: 'pie',
        height: 240,
        width: chartWidth,
      },
      title: {
        text: ''
      },
      series: [{
        name: 'Share',
        type: 'pie',
        innerSize: '60%', // Set inner size to make it a donut chart
        data: data1
      }],
      exporting: {
        enabled: false
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          colors: ['#FFBF3F', '#FFA500', '#F9423A', '#A0231D', '#057A88', '#173F35'],
          cursor: 'pointer',
          dataLabels: {
            format: '{point.y}', // Display name and percentage
            distance: 5 // Position data labels outside the pie slices
          },
          size: '100%',
          showInLegend: true
        }
      },
      tooltip: {
        pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
      },
      legend: {
        enabled: true,
        layout: 'horizontal',
        align: 'center',
        verticalAlign: 'bottom',
        itemStyle: {
          fontFamily: '"Poppins", sans-serif',
          fontSize: '12px',
          color: '#000'
        },
        symbolHeight: 10, // Set symbol height to make it a square
        symbolWidth: 10,  // Set symbol width to make it a square
        symbolRadius: 0 // Make legend symbol square
      }
    });  
  }

  DonutChart5() {    
    const data1 = [
      { name: 'Provider 1', y: 1500 },
      { name: 'Provider 2', y: 1000 },
      { name: 'Provider 3', y: 500 },
      { name: 'Provider 4', y: 2000 },
      { name: 'Provider 5', y: 5000 }
    ];

    const chartWidth = window.innerWidth > 1900 ? 360 : 270;    
  
    this.donutChart5 = new Chart({
      chart: {
        type: 'pie',
        height: 240,
        width: chartWidth,
      },
      title: {
        text: 'PREMIUM',
        style: {
          fontSize: '14px',
          color: '#015963',
          fontFamily: '"Poppins", sans-serif',
          fontWeight: 'bold'
        }
      },
      series: [{
        name: 'Share',
        type: 'pie',
        innerSize: '60%', // Set inner size to make it a donut chart
        data: data1
      }],
      exporting: {
        enabled: false
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          colors: ['#FFBF3F', '#FFA500', '#F9423A', '#A0231D', '#173F35'],
          cursor: 'pointer',
          dataLabels: {
            format: '{point.y}', // Display name and percentage
            distance: 5 // Position data labels outside the pie slices
          },
          size: '100%',
          showInLegend: true
        }
      },
      tooltip: {
        pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
      },
      legend: {
        enabled: true,
        layout: 'horizontal',
        align: 'center',
        verticalAlign: 'bottom',
        itemStyle: {
          fontFamily: '"Poppins", sans-serif',
          fontSize: '12px',
          color: '#000'
        },
        symbolHeight: 10, // Set symbol height to make it a square
        symbolWidth: 10,  // Set symbol width to make it a square
        symbolRadius: 0 // Make legend symbol square
      }
    });  
  }

  DonutChart6() {    
    const data1 = [
      { name: 'Provider 1', y: 15 },
      { name: 'Provider 2', y: 10 },
      { name: 'Provider 3', y: 5 },
      { name: 'Provider 4', y: 10 },
      { name: 'Provider 5', y: 40 }
    ];

    const chartWidth = window.innerWidth > 1900 ? 360 : 270;    
  
    this.donutChart6 = new Chart({
      chart: {
        type: 'pie',
        height: 240,
        width: chartWidth,
      },
      title: {
        text: 'PRODUCT',
        style: {
          fontSize: '14px',
          color: '#015963',
          fontFamily: '"Poppins", sans-serif',
          fontWeight: 'bold'
        }
      },
      series: [{
        name: 'Share',
        type: 'pie',
        innerSize: '60%', // Set inner size to make it a donut chart
        data: data1
      }],
      exporting: {
        enabled: false
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          colors: ['#FFBF3F', '#FFA500', '#F9423A', '#A0231D', '#173F35'],
          cursor: 'pointer',
          dataLabels: {
            format: '{point.y}%', // Display name and percentage
            distance: 5 // Position data labels outside the pie slices
          },
          size: '100%',
          showInLegend: true
        }
      },
      tooltip: {
        pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
      },
      legend: {
        enabled: true,
        layout: 'horizontal',
        align: 'center',
        verticalAlign: 'bottom',
        itemStyle: {
          fontFamily: '"Poppins", sans-serif',
          fontSize: '12px',
          color: '#000'
        },
        symbolHeight: 10, // Set symbol height to make it a square
        symbolWidth: 10,  // Set symbol width to make it a square
        symbolRadius: 0 // Make legend symbol square
      }
    });  
  }

  DonutChart7() {    
    const data1 = [
      { name: 'Provider 1', y: 1500 },
      { name: 'Provider 2', y: 1000 },
      { name: 'Provider 3', y: 500 },
      { name: 'Provider 4', y: 2000 },
      { name: 'Provider 5', y: 5000 }
    ];

    const chartWidth = window.innerWidth > 1900 ? 360 : 270;    
  
    this.donutChart7 = new Chart({
      chart: {
        type: 'pie',
        height: 240,
        width: chartWidth,
      },
      title: {
        text: 'PREMIUM',
        style: {
          fontSize: '14px',
          color: '#015963',
          fontFamily: '"Poppins", sans-serif',
          fontWeight: 'bold'
        }
      },
      series: [{
        name: 'Share',
        type: 'pie',
        innerSize: '60%', // Set inner size to make it a donut chart
        data: data1
      }],
      exporting: {
        enabled: false
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          colors: ['#FFBF3F', '#FFA500', '#F9423A', '#A0231D', '#173F35'],
          cursor: 'pointer',
          dataLabels: {
            format: '{point.y}', // Display name and percentage
            distance: 5 // Position data labels outside the pie slices
          },
          size: '100%',
          showInLegend: true
        }
      },
      tooltip: {
        pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
      },
      legend: {
        enabled: true,
        layout: 'horizontal',
        align: 'center',
        verticalAlign: 'bottom',
        itemStyle: {
          fontFamily: '"Poppins", sans-serif',
          fontSize: '12px',
          color: '#000'
        },
        symbolHeight: 10, // Set symbol height to make it a square
        symbolWidth: 10,  // Set symbol width to make it a square
        symbolRadius: 0 // Make legend symbol square
      }
    });  
  }

  DonutChart8() {    
    const data1 = [
      { name: 'Provider 1', y: 15 },
      { name: 'Provider 2', y: 10 },
      { name: 'Provider 3', y: 5 },
      { name: 'Provider 4', y: 10 },
      { name: 'Provider 5', y: 40 }
    ];

    const chartWidth = window.innerWidth > 1900 ? 360 : 270;    
  
    this.donutChart8 = new Chart({
      chart: {
        type: 'pie',
        height: 240,
        width: chartWidth,
      },
      title: {
        text: 'PRODUCT',
        style: {
          fontSize: '14px',
          color: '#015963',
          fontFamily: '"Poppins", sans-serif',
          fontWeight: 'bold'
        }
      },
      series: [{
        name: 'Share',
        type: 'pie',
        innerSize: '60%', // Set inner size to make it a donut chart
        data: data1
      }],
      exporting: {
        enabled: false
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          colors: ['#FFBF3F', '#FFA500', '#F9423A', '#A0231D', '#173F35'],
          cursor: 'pointer',
          dataLabels: {
            format: '{point.y}%', // Display name and percentage
            distance: 5 // Position data labels outside the pie slices
          },
          size: '100%',
          showInLegend: true
        }
      },
      tooltip: {
        pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
      },
      legend: {
        enabled: true,
        layout: 'horizontal',
        align: 'center',
        verticalAlign: 'bottom',
        itemStyle: {
          fontFamily: '"Poppins", sans-serif',
          fontSize: '12px',
          color: '#000'
        },
        symbolHeight: 10, // Set symbol height to make it a square
        symbolWidth: 10,  // Set symbol width to make it a square
        symbolRadius: 0 // Make legend symbol square
      }
    });  
  }

  embedPowerBIReport(): void {
    const embedConfig: pbi.IEmbedConfiguration = {
      type: 'report',
      id: 'b6f1e49b-fe43-49ea-8758-dbbd90c184ef', // Replace with your Power BI report ID
      embedUrl: 'https://app.powerbi.com/reportEmbed?reportId=b6f1e49b-fe43-49ea-8758-dbbd90c184ef&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly9XQUJJLUlORElBLUNFTlRSQUwtQS1QUklNQVJZLXJlZGlyZWN0LmFuYWx5c2lzLndpbmRvd3MubmV0IiwiZW1iZWRGZWF0dXJlcyI6eyJ1c2FnZU1ldHJpY3NWTmV4dCI6dHJ1ZX19', // Replace with your Power BI embed URL
      accessToken: 'H4sIAAAAAAAEAB3Tx66DVgBF0X95UyKB4RpwpAwA03sxbQam915ulH_PS-b7TJZ0_v6xkrsbk-znzx9kRwPVRdTKAoHdZSvpXRgEnb3mycKn1bqr8OyX5Nye5fYwo8pc2IT2jmza0tcMlkgeqvsC_R7o15NgSMXkJJpkmYfNHMLc4EfW3CEg9CikqaR05AA4fHYbAobVW38MNtzXc-Vsw_WsbXNMTKFiiqXfjQBMn0Rh5nL66Q9JUoT-HeRn2X0NRyyRWtZseeL44kPeeuZ9uVFhFbMwAHvYhOcUhDxNT7EpovoOMnS2yEgiz2JEeawaKaucpZoMusPIuHNiwER37uCSimZXWYrMr0qkZPeCw0uqdSeSBMbZOhKV2pfVnSABS1YN8x3Byz2Ljn8Xc60RbZQsUGQyocbn08n3YzWURL7652qw5VJX4GUIWfWV9I1riAj9tvbLIc5EiDYD9YY4lMy3poKwBkIlxwLRFZ0LnIEWsADjVH2ZHl0YIwIWU72oryqOlA-JNtLL-PJOpJ4zeW3ZJvK6Mhbl1SrujZd4HCEUg7gP7nNNB4rSbcqAIp5EEjmgqvtI5fMa2my-fthkMVdUmRmdV-rOuRmQA1RJazwB7wRfq3QokFl6TgjgKB31SXqdrmYNRN38rArJP_t8FphZcGdcvSiGUXq52-kK5GC_jyRMgWcMGoUJ4AvZjjRXSGkbwiKyip1cN0z0K6ugtUReYpUh6_iU1CJco2eC4LOyQk04Ug_EWG7Sh9nT5Fgd5LlXQRhT8YPpQZqwqRShbK5DQTF7631ECbAYWA1IfklcQq4-pPKK9u3X7pHfPh8uIvCo5ssrcy_ECOJtBl59CpL9PiSb9uFuczW3mXR0zinqLSMnKN-8yE60SbNZ0eqTLGsbNk39IExnX5OfP3645Z62Uc3v3zvF0M_bqywnx1WyRiD0IUl_N8xcBoF6WFlANPagNlNOUKH7mFdJd0n8ZIodUxFna-ILML21vh8RlX4z4zgZPfkiVlUb9TpTVNCgqjLRzXe6APJhIOQ-ssi1g8-KnoI8-RHkTVilNu8RfIB_lpA31Q1tpZ5RPDbCY6cmGBODkXrhmOfZQbI5GcHgwjqKhwHR0CBYNVAhtS5PVFWLcT2VNceUrr3wMsH5nt3DwFjRrdn3hj4s-QmFVWxisRK9OoR2hpPvR8zRcquigj_0JMcdme-aAflOEO2QyDSgdlbnCoMwo8ZnPyOjEVUYXdQb7Mqw79kgbJb2robD1t7xK3lOWFcPt_3XX_8x31OVL7L_q0zQ5dlCacJa9GxkVqncCYjM_5Vbl0Oy7Uv-m0ULbqDa7lKBRvqXhlLxB-YDpiEspPBgfEHlKXHlIjcTEyHjWmom9qIPcjb4NhOnwb5fzZxAN1by0b2mUY0-OUYbEM-ec7tMapyvuYQu38hvOoiHoxGnIy24uJhvB1fyxzh8vvZLlkKa67g4NOMZ42Y5s5bd2Wxupl7sbkuyzqhl8dYv3P9Eyzi_2_YARKOl6C50XkTf6FILsMlhxcZukgwpomtQYiZtdp11vsQ2alQFxI4juXKQoA4WE0_aZM0D9_ccrcxAwbGG61sHURVPVfSspbr9mXtWVm8WR6TG1Qua8Bm9YCtUeDkL9V6cuC0tRQaOAx7p17iynp6StXu7hIsY5y_zP_8C1sGduEIGAAA=.eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly9XQUJJLUlORElBLUNFTlRSQUwtQS1QUklNQVJZLXJlZGlyZWN0LmFuYWx5c2lzLndpbmRvd3MubmV0IiwiZXhwIjoxNzIzNDYxMjA0LCJhbGxvd0FjY2Vzc092ZXJQdWJsaWNJbnRlcm5ldCI6dHJ1ZX0=', // Replace with your Power BI access token
      tokenType: pbi.models.TokenType.Embed,
      settings: {
        filterPaneEnabled: false,
        navContentPaneEnabled: false,
      }
    };

    const powerbi = new pbi.service.Service(pbi.factories.hpmFactory, pbi.factories.wpmpFactory, pbi.factories.routerFactory);
    powerbi.embed(this.reportContainer.nativeElement, embedConfig);
  }

}
